var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-select',{staticClass:"form-control",model:{value:(_vm.localValue),callback:function ($$v) {_vm.localValue=$$v},expression:"localValue"}},[_c('option',[_vm._v("Select")])])}
var staticRenderFns = []

export { render, staticRenderFns }